import { IonButton, IonIcon, IonItem, IonLabel, IonSpinner, IonText } from '@ionic/react';
import { refresh } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import { syncTimer } from '../../../common/interval';
import { IRepairOrderSyncStatus } from '../../../models/dms/repairOrder.model';
import { useDataSync } from '../../../providers/DataSyncProvider';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setRepairOrderHasSyncStoreAsync } from '../../../store/repairOrderSyncSlice';

interface IComponentProps {
  title: string;
}

let repairOrdersTime: { timestamp: number; sync?: IRepairOrderSyncStatus } = {
  timestamp: 0,
  sync: undefined,
};

const RepairOrdersSyncItem: React.FC<IComponentProps> = ({ title }) => {
  const { enableOfflineMode } = useAppSelector((state) => state.settings);
  const {
    state: { repairOrderSyncTimer },
  } = useDataSync();

  const dispatch = useAppDispatch();

  const [repairOrderTimestamp, setRepairOrderTimestamp] = useState(0);
  const { repairOrderSync, repairOrderSyncLoading } = useAppSelector((state) => state.repairOrderSync);

  useEffect(() => {
    const syncSub = syncTimer.subject.subscribe((id) => {
      if (id > 0) {
        const now = new Date().getTime();

        // Repair orders
        if (repairOrdersTime.sync) {
          if (repairOrdersTime.sync.timestamp <= 0) {
            repairOrdersTime.timestamp = -1;
          } else {
            const timeDiff = now - repairOrdersTime.sync.timestamp;
            repairOrdersTime.timestamp = Math.floor(timeDiff / 60000);
            setRepairOrderTimestamp(repairOrdersTime.timestamp);
          }
        }
      }
    });

    return () => syncSub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    repairOrdersTime.sync = repairOrderSync;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repairOrderSync]);

  const handleRefreshButtonClick = () => {
    dispatch(setRepairOrderHasSyncStoreAsync(false));
    repairOrderSyncTimer?.fire();
  };

  return (
    <IonItem>
      <IonLabel text-wrap>
        <IonText>
          <IonLabel>{title}</IonLabel>
        </IonText>
        {(() => {
          switch (repairOrderSyncLoading) {
            case false:
              return (
                <IonText color="medium">
                  Last sync - <span>{repairOrderTimestamp} minutes</span>
                </IonText>
              );
            case true:
              return <IonText color="medium">Last sync - synchronising...</IonText>;
          }
        })()}
      </IonLabel>
      {enableOfflineMode && (
        <IonButton slot="end" color="primary" disabled={repairOrderSyncLoading} onClick={() => handleRefreshButtonClick()}>
          {(() => {
            switch (repairOrderSyncLoading) {
              case false:
                return <IonIcon icon={refresh} color="secondary" />;
              case true:
                return <IonSpinner name="lines-small" color="secondary"></IonSpinner>;
            }
          })()}
        </IonButton>
      )}
    </IonItem>
  );
};

export default RepairOrdersSyncItem;
